export default __webpack_public_path__ + "static/bg-tac-7f327299c00a29a5b990a51d86a4b6f9.webp";